import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import ZwibblerComponent from "./ZwibblerComponet";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const PopOutEditor = ({
  popOutEditorDialogOpen,
  setPopOutEditorDialogOpen,
}: {
  popOutEditorDialogOpen: boolean;
  setPopOutEditorDialogOpen: any;
}) => {
  const handleClickOpen = () => {
    setPopOutEditorDialogOpen(true);
  };

  const handleClose = () => {
    setPopOutEditorDialogOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={popOutEditorDialogOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div
          className="player absolute top-[70px] left-[20px] w-[1475px] h-[200px]"
          role="button"
          tabIndex={0}
        >
          <ZwibblerComponent />
        </div>
      </Dialog>
    </React.Fragment>
  );
};
